import { memo } from 'react';
import { UseMutationResult } from 'react-query';

import { Address } from '@/domain/address/models/address';
import { Modal } from '@/shared/components/Modal';
import { executeEvent } from '@/shared/events/Firebase/firebaseEvents';
import { animationLoadOptions } from '@/shared/utils/loading';
import { Grid, Text, Button } from '@develop-fapp/ui-kit-fapp';

import * as S from './styles';

interface DialogDeleteProps {
  isOpen: boolean;
  onClose: () => void;
  deleteAddressMutation: UseMutationResult<Address[], unknown, void, unknown>;
}

const Dialog: React.FC<DialogDeleteProps> = ({
  isOpen,
  onClose,
  deleteAddressMutation: { mutate, isLoading, isSuccess, isError },
}) => {
  const handleDeleteAddress = () => {
    executeEvent('click_delete_address', {});
    mutate();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <S.Wrapper>
        <Text variant="h5" weight="bold">
          Deseja excluir o endereço?
        </Text>
        <div>
          <Text variant="h8" weight="medium">
            Você está prestes a excluir esse endereço.
          </Text>
          <Text variant="h8" weight="medium">
            Tem certeza que quer fazer isso?
          </Text>
        </div>
        <Grid xs="1fr 1fr" spacing="8px">
          <Button color="primary" variant="outlined" onClick={() => onClose()}>
            Cancelar
          </Button>
          <Button
            color="error"
            variant="contained"
            disabled={isLoading}
            onClick={handleDeleteAddress}
            animationLoadOptions={animationLoadOptions(
              isLoading,
              isSuccess,
              isError,
            )}
          >
            Excluir endereço
          </Button>
        </Grid>
      </S.Wrapper>
    </Modal>
  );
};

export const DialogDeleteAddress = memo(Dialog);
